import { useEffect } from 'react';

import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../context/Auth';

import { useSignInContext } from './SignInContext';
import SignInForm from './SignInForm';
import SignIn2FA from './SignIn2FA';
import SignInBypass2FA from './SignInBypass2FA';
import SignInRequest2FABypass from './SignInRequest2FABypass';
import SignInConfirmEmailChange from './SignInConfirmEmailChange';
import SignInConfirmEmail from './SignInConfirmEmail';

import { SignupStatusEnum } from '../../constants/enums';
import HomeFrame from './HomeFrame';

const SignIn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { user } = useAuth();
  const { state } = useSignInContext();

  useEffect(() => {
    if (!user?.emailVerified) {
      return;
    }

    if (user?.username && user?.signupStatus !== 'COMPLETED') {
      navigate('/strategies');
      return;
    }

    if (user.profiles.items.length > 1) {
      navigate('/choose-account');
    } else if (user.profiles.items.length === 1) {
      navigate('/strategies');
    } else {
      navigate(SignupStatusEnum[user.signupStatus] || '/');
    }
  }, [user]);

  return (
    <HomeFrame>
      {state.step === '2FA' ? (
        <SignIn2FA />
      ) : state.step === 'REQUEST_2FA_BYPASS' ? (
        <SignInRequest2FABypass />
      ) : state.step === 'BYPASS_2FA' ? (
        <SignInBypass2FA />
      ) : state.step === 'CONFIRM_EMAIL' ? (
        <SignInConfirmEmail />
      ) : state.step === 'CONFIRM_EMAIL_CHANGE' ? (
        <SignInConfirmEmailChange />
      ) : (
        <SignInForm />
      )}
    </HomeFrame>
  );
};

export default SignIn;
